import React from "react";
import { FaTimes } from "react-icons/fa";
import { Product } from "../../models/product";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const ImageCard: React.FC<{
  product: Product;
  selected: boolean;
  onSelectChange: (sku: string, selected: boolean) => void;
}> = (props) => {
  return (
    <div className="compare-page-img-wrap">
      <div
        className={`compare-page-img-container ${
          props.selected ? "compare-page-image-selected" : ""
        }`}
        onClick={() => {
          props.onSelectChange(props.product.sku, !props.selected);
        }}
      >
        <img
          className="compare-page-image"
          alt={props.product.name}
          src={props.product.image}
        ></img>
        {props.selected && (
          <div
            className="compare-page-image-unselect"
            onClick={() => {
              props.onSelectChange(props.product.sku, false);
            }}
          >
            <FaTimes />
          </div>
        )}
      </div>
    </div>
  );
};

const ImageSlide: React.FC<{
  slidesToShow: number;
  products: Product[];
  selectedProducts: Product[];
  maxCompareNumber: number;
  onSelectChange: (sku: string, selected: boolean) => void;
}> = (props) => {
  const handleSelectionChange = (sku: string, selected: boolean) => {
    if (
      (selected && props.selectedProducts.length >= props.maxCompareNumber) ||
      (!selected && props.selectedProducts.length <= 1)
    ) {
      return;
    }
    props.onSelectChange(sku, selected);
  };
  return props.products.length <= props.slidesToShow ? (
    <div>
      {props.products.map((product) => {
        const selected = props.selectedProducts.some(
          (p) => p.sku === product.sku
        );
        return (
          <ImageCard
            selected={selected}
            product={product}
            key={product.sku}
            onSelectChange={handleSelectionChange}
          />
        );
      })}
    </div>
  ) : (
    <Slide
      slidesToShow={props.slidesToShow}
      slidesToScroll={1}
      autoplay={false}
    >
      {props.products.map((product) => {
        const selected = props.selectedProducts.some(
          (p) => p.sku === product.sku
        );
        return (
          <ImageCard
            selected={selected}
            product={product}
            key={product.sku}
            onSelectChange={handleSelectionChange}
          />
        );
      })}
    </Slide>
  );
};

export default ImageSlide;
